import { render, staticRenderFns } from "./NoteCreationForCourse.vue?vue&type=template&id=5f1be762&"
import script from "./NoteCreationForCourse.vue?vue&type=script&lang=js&"
export * from "./NoteCreationForCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports